// extracted by mini-css-extract-plugin
module.exports = {"packingGroup":"A0Gpc","packingGroup-title":"OBgGn","packingGroup-items":"FVabT"};